import React from "react";
import Banner from "./Banner";
import Trusted from "./Trusted";
import dynamic from "next/dynamic";
const RFPForm = dynamic(() => import("./Quote"),{ssr: true});
const Process = dynamic(() => import("./process"),{ssr: true});
const Testimonials = dynamic(() => import("./Review"),{ssr: true});
const Accordion = dynamic(() => import("./accordion"),{ssr: true});
const Strategies = dynamic(() => import("./Strategies"),{ssr: true});
const BuildSection = dynamic(() => import("./BuildSection"),{ssr: true});
const StrategyKeys = dynamic(() => import("./StrategyKeys"),{ssr: true});
const ClientSolution = dynamic(() => import("./Client-solution"),{ssr: true});
const RequestProposalBusiness = dynamic(() => import("./Business"),{ssr: true});
const Faq = dynamic(() => import("./detail-post/faq"),{ssr: true});

interface TechnologyProps {
  blocks?: any;
  slug: string;
  title?: string;
  breadcrumbs?: any;
  isMobile?: boolean;
}

const TechnologyNew: React.FC<TechnologyProps> = ({
  blocks,
  slug,
  title,
  breadcrumbs,
  isMobile,
}) => {
  const renderBlock = (block: any, i: number) => {
    switch (block.__component) {
      case "blocks.home-new-banner":
        return (
          <Banner
            key={i}
            data={block}
            slug={slug}
            title={title ?? ""}
            breadcrumbs={breadcrumbs}
          />
        );

      case "blocks.2025-home-trusted-by":
        return <Trusted key={i} data={block} />;

      case "blocks.contact-us-case-study":
        return <ClientSolution key={i} data={block} />;

      case "blocks.tech-service-processes":
        return <Accordion key={i} data={block} />;

      case "blocks.tech-service-cta":
        return <BuildSection key={i} block={block} />;

      case "blocks.faq":
        const firstFaqIndex =
          blocks?.findIndex((b: any) => b.__component === "blocks.faq") ?? -1;

        return block.theme !== "muted" || i == firstFaqIndex ? (
          <Accordion key={i} data={block} />
        ) : (
          <section
            key={i}
            className="bg-white xl:py-[90px] md:py-[80px] py-[56px]"
          >
            <div className="container mx-auto">
              <Faq items={block} />
            </div>
          </section>
        );

      case "blocks.strategies":
        return block?.["key-points"]?.length > 0 ? (
          <StrategyKeys key={i} data={block} />
        ) : (
          <Strategies key={i} data={block} isMobile={isMobile} />
        );

      case "blocks.testimonials":
        return <Testimonials key={i} data={block} />;

      case "blocks.home-new-development-process":
        return <Process key={i} data={block} />;

      case "blocks.hiring-modal":
        return (
          <RequestProposalBusiness key={i} data={block}  />
        );

      case "blocks.home-new-form":
        return <RFPForm key={i} data={block} />;

      default:
        return null;
    }
  };

  return (
    <div className="nome-new tech-pad bg-one">
      {blocks?.length > 0 &&
        blocks.map((block: any, i: number) => renderBlock(block, i))}
    </div>
  );
};

export default TechnologyNew;
